<script>
  import { detected_fonts, system_fonts } from '../../stores'
  import Insert from '../../elements/Insert.svelte'
  import UAParser from 'ua-parser-js'
  import Insert_YourFonts from './YourFonts.svelte'

  export let inbetween_counter
  export let selected_previews_count
  export let filtered_preview_count
  export let insert_position
  export let show_font_detection_insert

  const uaParser = new UAParser()
  const os = uaParser.getOS()

  function backToTop() {
    window.scrollTo({
      top: 0,
      left: 0,
      behavior: 'smooth'
    })
  }
</script>

<!-- Before Preview -->
{#if insert_position === 'before_previews'}
  {#if show_font_detection_insert}
    <Insert_YourFonts {insert_position}/>
  {:else if filtered_preview_count > 0}
    <Insert {insert_position}>
      <span slot="title">
        Here&rsquo;s how your text looks<br>
        with the fonts on your computer
      </span>
      <span slot="text">
        Start scrolling and we will help you find the right one
      </span>
    </Insert>
  {/if}
{/if}

<!-- Between Previews -->
{#if insert_position === 'between_previews'}

  <!-- Between Previews 1 -->
  {#if inbetween_counter=== 1}
    <Insert {insert_position}>
      <span slot="title">
        Click and select the ones you like
      </span>
      <span slot="text">
        You will be able to compare them later
      </span>
    </Insert>
  {/if}

  <!-- Between Previews 2 -->
  {#if inbetween_counter=== 2}
    <Insert {insert_position}>
      <span slot="title">
        Once you have some alternatives,<br>
        Click &ldquo;Filter selected fonts&rdquo;
      </span>
      <span slot="text">
        The filter button appears on top right when you select a font
      </span>
    </Insert>
  {/if}

   <!-- Between Previews 3 -->
  {#if inbetween_counter=== 3}
    <Insert {insert_position}>
      <span slot="title">
        Exclude default fonts
      </span>
      <span slot="text">
        Head over to "Your Fonts" to see only the fonts you have installed yourself.
        <small>
          Click the "Your Fonts" section on the <span class="clickable" on:click={backToTop}>top of the page</span>
        </small>
      </span>
    </Insert>
  {/if}
  
  <!-- Between Previews 6 -->
  {#if inbetween_counter=== 6}
    <Insert {insert_position}>
      <span slot="title">
        Remember to pick as you scroll
      </span>
      <span slot="text">
        You don't need to decide while scrolling. Pick the ones you like <br>and you can narrow down your options later.
      </span>
    </Insert>
  {/if}

{/if}

<!-- After of Previews -->
{#if insert_position === 'after_previews'}
  {#if selected_previews_count === 0 && filtered_preview_count > 50}
    <Insert {insert_position}>
      <span slot="title">
        Didn't find anything interesting?
      </span>
      <span slot="text">
        It's better to click and select the fonts that look slightly interesting. Once you've gone through all your fonts you can narrow down your options and pick the best among them.
        <small>
          Would you like to try again? Just scroll to the <span class="clickable" on:click={backToTop}>top of the page</span>.
        </small>
      </span>
    </Insert>
  {:else if selected_previews_count > 0}
    <Insert {insert_position}>
      <span slot="title">
        Great! You've selected {selected_previews_count} fonts
      </span>
      <span slot="text">
        Click the &ldquo;Filter selected fonts&rdquo; button on top right to check them out
      </span>
    </Insert>
  {/if}
{/if}

<!-- Filtered Previews -->
{#if insert_position === 'filtered_previews'}
  <Insert {insert_position}>
    <span slot="title">
      Here&rsquo;s your shortlist;<br>
      Now, compare and pick the best
    </span>
    <span slot="text">
      Once you find the font you like, note it's name to use it anywhere else
      <small>
        You can also use Wordmark to <br>
        <a class="pill_buttons" href="/help/tagging/" target="_blank"> ↗︎ categorize your fonts</a>
        <a class="pill_buttons" href="/help/google-fonts/" target="_blank"> ↗︎ discover new fonts</a>
        <a class="pill_buttons" href="/help/exporting-an-image/" target="_blank"> ↗︎ share a selection with customers</a>
        <a class="pill_buttons" href="/help/printing-fonts/" target="_blank"> ↗︎ print selected fonts</a>
        <a class="pill_buttons" href="/help/export-to-cricut/" target="_blank"> ↗︎ export to Cricut and Sihouette</a>
      </small>
    </span>
  </Insert>
{/if}

<style>
  .clickable {
    color: var(--c-text-faded);
    text-decoration: underline;
  }
  .clickable:hover {
    color: var(--c-text);
    cursor: pointer;
  }
  
  .pill_buttons {
    display: inline-block;
    height: 3rem;
    margin: 0.5rem;
    padding: 0 0.75rem;
    border-radius: 1.5rem;
    background-color: var(--c-textfield-bg);
    font-size: 1.6rem;
    text-decoration: none;
  }
</style>